import { FETCH_LE_SUBSCRIPTIONS, FETCH_LE_SUBSCRIPTIONS_V2, FETCH_RESUBSCRIPTION_DISMISSED_DATE, FETCH_TRAVEL_PREFERENCES_DISMISSED, UPDATE_LE_SUBSCRIPTIONS, UPDATE_LE_SUBSCRIPTIONS_V2, UPDATE_RESUBSCRIPTION_DISMISSED_DATE, UPDATE_TRAVEL_PREFERENCES_DISMISSED } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

const initialSettingsV1: App.LESubscriptionsSettings = {
  appPushSubscribed: false,
  curatedCollectionSubscribed: false,
  emailSubscribed: false,
  myJourneySubscribed: false,
  smsSubscribed: false,
  todaysEscapesCadence: 'daily',
  todaysEscapesSubscribed: false,
  webPushSubscribed: false,
  whatsAppSubscribed: false,
}

const initialSettings: App.SubscriptionPreferencesV2 = {
  appPushSubscribed: false,
  curatedCollectionSubscribed: false,
  emailSubscribed: false,
  myJourneySubscribed: false,
  smsSubscribed: false,
  todaysEscapesCadence: 'DAILY',
  todaysEscapesSubscribed: false,
}

export const initialLESubscriptionState: App.LESubscriptionsState = {
  settings: initialSettings,
  fetching: false,
  updating: false,
  fetchError: '',
  updateError: '',
  resubscribeDismissedAt: undefined,
  emailSubscribedUpdatedAt: undefined,
  fetchingResubscribeDismissedAt: false,
  hasDismissedTravelPreferencesModal: true,
  fetchingTravelPreferencesDismissed: false,

  v1Data: {
    settings: initialSettingsV1,
    fetching: false,
    updating: false,
    fetchError: '',
    updateError: '',
  },
}

const apiCalls = apiReducerSwitch<App.LESubscriptionsState>({
  [FETCH_LE_SUBSCRIPTIONS]: {
    request: () => ({
      v1Data: {
        ...initialLESubscriptionState.v1Data,
        fetching: true,
        fetchError: '',
        updateError: '',
      },
    }),
    success: (state, action) => ({
      ...state,
      v1Data: {
        ...state.v1Data,
        settings: action.data,
        fetching: false,
        fetchError: '',
      },
    }),
    failure: (state, action) => ({
      ...state,
      v1Data: {
        ...state.v1Data,
        fetching: false,
        fetchError: action.error,
      },
    }),
  },
  [FETCH_LE_SUBSCRIPTIONS_V2]: {
    request: () => ({
      fetching: true,
      fetchError: '',
      updateError: '',
    }),
    success: (state, action): Partial<App.LESubscriptionsState> => ({
      ...state,
      settings: {
        ...state.settings,
        ...action.data.settings,
      },
      emailSubscribedUpdatedAt: action.data.emailSubscribedUpdatedAt,
      fetching: false,
      fetchError: '',
    }),
    failure: (state, action) => ({
      ...state,
      fetching: false,
      fetchError: action.error,
    }),
  },
  [UPDATE_LE_SUBSCRIPTIONS]: {
    request: () => ({
      v1Data: {
        ...initialLESubscriptionState.v1Data,
        updating: true,
        fetchError: '',
        updateError: '',
      },
    }),
    success: (state, action) => ({
      ...state,
      v1Data: {
        ...state.v1Data,
        settings: action.data,
        updating: false,
        updateError: '',
      },
    }),
    failure: (state, action) => ({
      ...state,
      v1Data: {
        ...state.v1Data,
        updating: false,
        updateError: action.error,
      },
    }),
  },
  [UPDATE_LE_SUBSCRIPTIONS_V2]: {
    request: () => ({
      updating: true,
      fetchError: '',
      updateError: '',
    }),
    success: (state, action) => ({
      ...state,
      settings: {
        ...state.settings,
        ...action.data.settings,
      },
      emailSubscribedUpdatedAt: action.data.emailSubscribedUpdatedAt,
      updating: false,
      updateError: '',
    }),
    failure: (state, action) => ({
      ...state,
      updating: false,
      updateError: action.error,
    }),
  },
  [FETCH_RESUBSCRIPTION_DISMISSED_DATE]: {
    request: () => ({
      fetchingResubscribeDismissedAt: true,
    }),
    success: (state, action) => ({
      ...state,
      fetchingResubscribeDismissedAt: false,
      resubscribeDismissedAt: action.data,
    }),
  },
  [FETCH_TRAVEL_PREFERENCES_DISMISSED]: {
    request: () => ({
      fetchingTravelPreferencesDismissed: true,
    }),
    success: (state, action) => ({
      ...state,
      fetchingTravelPreferencesDismissed: false,
      hasDismissedTravelPreferencesModal: action.data,
    }),
    failure: (state) => ({
      ...state,
      fetchingTravelPreferencesDismissed: false,
      hasDismissedTravelPreferencesModal: false,
    }),
  },
  [UPDATE_TRAVEL_PREFERENCES_DISMISSED]: {
    request: () => ({
      hasDismissedTravelPreferencesModal: true,
    }),
  },
  [UPDATE_RESUBSCRIPTION_DISMISSED_DATE]: {
    success: (state, action) => ({
      ...state,
      resubscribeDismissedAt: action.data,
    }),
  },
})

export default createAppReducer<App.LESubscriptionsState>(initialLESubscriptionState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
